import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { NavBar, Svg, Icon, IconButton, Dropdown } from '../';
import { Menubar } from 'primereact/menubar';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TieredMenu } from 'primereact/tieredmenu';
import BackgroundColor from '../../pages/Colors/BackgroundColor';

function Header({
  children,
  menuOptions,
  isReturnEnabled,
  onClickReturnButton,
  isSticky,
  WhiteLabeling,
  setPositionMenu,
  ...props
}): ReactNode {

  const { t } = useTranslation('Header');

  const mobilecheck = () => {
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  const ocultarBtnAslEBaixar = (memoPositionMenu) => {
    const buttons = ['btnAslViewer', 'btnDownload'];
    buttons.forEach(button => {
      document.getElementById(button).style.display = memoPositionMenu === "1" ? 'none' : '';
    });
  }

  const setStatePositionMenu = (positionMenu) => {
    try {
      setPositionMenu(positionMenu);
    } catch (ex) { }
  }

  const getPositionMenu = () => {
    try {
      const memoPositionMenu = localStorage.getItem('positionMenu');
      if (memoPositionMenu) {
        ocultarBtnAslEBaixar(memoPositionMenu);
        const positionMenu = JSON.parse(memoPositionMenu);
        setStatePositionMenu(positionMenu);
        return positionMenu;
      }
    } catch (ex) { }
    return 0;
  }

  const menu = useRef(null);
  const [optionsMenuHeader, setOptionsMenuHeader] = useState([]);
  const [isMobile, setIsMobile] = useState(mobilecheck());
  const autenticado = JSON.parse(sessionStorage.getItem('auth')) !== null;
  const [dialogSobre, setDialogSobre] = useState(false);
  const [dialogConfirmacao, setDialogConfirmacao] = useState(false);
  const [textoMenu, setTextoMenu] = useState('Horizontal');
  const [countMenuPosition, setCountMenuPosition] = useState(getPositionMenu());
  const [acessoViewer] = useState(window.location.href.indexOf("viewer?") > 0);

  useEffect(() => {
    if (optionsMenuHeader.length === 0)
      autenticado ? menuAdm() : menuClient();
    positionMenu('init');
  }, [optionsMenuHeader])

  const imprimirImagem = () => {
    const paciente = document.getElementById('top-pacienteNome').innerText;
    const exame = document.getElementById('top-exame').innerText;
    const cornerstoneCanvas = document.body.getElementsByClassName('cornerstone-canvas');
    const widthImg = `${cornerstoneCanvas.length > 1 ? (98.9 / 2) : 100}%`;
    let imagens = "";
    var cnt = 0;
    for (let index = 0; index < cornerstoneCanvas.length; index++) {
      if (cornerstoneCanvas[index]) {
        imagens += `<img src="${cornerstoneCanvas[index].toDataURL()}" Width="${widthImg}" /> `;
        cnt++;
        if (cnt == 2) {
          imagens += '<br>';
          cnt = 0;
        }
      }
    }
    var win = window.open('about:blank', "_new");
    win.document.open();
    win.document.write([
      '<html>',
      '   <head>',
      '   <title>Tztion WebViewer</title>',
      '   </head>',
      '   <body onload="window.print()" onafterprint="window.close()">',
      '   </br>',
      `   <strong>${paciente}</strong>`,
      `   ${exame}</br></br>`,
      imagens,
      //`   </br></br><div style="text-align:right">${sessionStorage.getItem('versao')}</div>`,
      '   </body>',
      '</html>'
    ].join(''));
    win.document.close();
  }

  const btnImprimir = {
    title: "Imprimir",
    icon: "print",
    onClick: () => {
      imprimirImagem();
    },
    style: { display: acessoViewer ? '' : 'none' }
  };

  const btnListaExames = {
    title: "Listar Exames",
    icon: "list-bullets",
    onClick: () => {
      window.location.href = window.location.origin;
    }
  };

  const btnPreferencias = {
    title: t('Preferences'),
    icon: "user",
    onClick: () => {
      menuOptions[1].onClick();
    }
  };

  const btnSobre = {
    title: "Sobre",
    icon: "info",
    onClick: () => {
      setDialogSobre(true);
    }
  };

  const menuClient = () => {
    const optionsValue = [
      btnImprimir,
      btnPreferencias,
      btnSobre
    ];
    setOptionsMenuHeader(optionsValue);
  }

  const menuAdm = () => {
    let optionsValue = [];
    if (acessoViewer)
      optionsValue.push(btnImprimir, btnListaExames)
    optionsValue.push(btnPreferencias, btnSobre);
    setOptionsMenuHeader(optionsValue);
  }

  const animeMenu = (elDivMenu) => {
    elDivMenu.style.opacity = '0';
    setTimeout(() => {
      elDivMenu.style.opacity = '1';
    }, 500);
  }

  const savePositionMenu = (position) => {
    setStatePositionMenu(position);
    localStorage.setItem('positionMenu', position);
  }

  const positionMenu = (start) => {

    if (!isReturnEnabled)
      return;

    try {
      let countPosition = start ? countMenuPosition : countMenuPosition + 1;
      if (countPosition > 2)
        countPosition = 0;

      setCountMenuPosition(countPosition);
      savePositionMenu(countPosition);

      const elDivMain = document.getElementById('divMain');
      const elMenuContainer = document.getElementById('divMenuContainer');
      const elMenuHorizontal = document.getElementById('menuHorizontal');
      const elMenuVertical = document.getElementById('menuVertical');
      const elDivToolBar = document.getElementById('divToolBar');
      const elDivPanel = document.getElementById('divPanel');

      if (countPosition === 1) {
        elDivMain.classList.add('flex');
        elDivToolBar.classList.remove('flex');
        elMenuContainer.classList.remove('layout-menu-container-b');
        elMenuContainer.classList.remove('layout-menu-container-h');
        elMenuContainer.classList.add('layout-menu-container-v');
        elMenuVertical.append(elMenuContainer);
        elDivPanel.style.height = 'calc(100vh - 70px)';
        elDivPanel.style.transition = 'height 0.5s ease 0s !important';
        setTextoMenu('Vertical');
        animeMenu(elMenuContainer);
        return;
      }

      if (countPosition === 0 || countPosition === 2) {
        elDivMain.classList.remove('flex');
        elDivToolBar.classList.add('flex');
        elMenuContainer.classList.remove('layout-menu-container-v');
        elMenuContainer.style.marginBottom = '10';
        elMenuContainer.classList.remove('layout-menu-container-b');
        elMenuContainer.classList.add('layout-menu-container-h');
        elMenuHorizontal.append(elMenuContainer);
        elDivPanel.style.height = 'calc(100vh - 140px)';
        elDivPanel.style.transition = 'height 0.5s ease 0s !important';
        setTextoMenu('Horizontal');
        elMenuHorizontal.removeAttribute('style');
        animeMenu(elMenuContainer);
      }

      if (countPosition === 2) {
        elMenuHorizontal.style.opacity = '0';
        elMenuContainer.style.marginBottom = '0';
        elMenuHorizontal.style.position = 'absolute';
        elMenuHorizontal.style.zIndex = '9999';
        elMenuHorizontal.style.bottom = '0';
        elMenuHorizontal.style.width = '100%';
        elMenuContainer.classList.remove('layout-menu-container-h');
        elMenuContainer.classList.add('layout-menu-container-b');
        setTextoMenu('Bottom');
        animeMenu(elMenuHorizontal);
      }
    } catch (ex) {
      console.log(ex);

    }

  }

  const menuStart = <div style={{ display: 'flex' }}>
    <a href={window.location.origin}><img alt="logo" src="/layout/logo.png" style={{ maxHeight: '40px' }} className="p-mr-2"></img></a>
    <Dropdown id="options" size="150px" showDropdownIcon={false} list={optionsMenuHeader}>
      <IconButton
        id={'options-settings-icon'}
        variant="text"
        color="inherit"
        className="text-primary-active"
      >
        <Icon name="menu-top" />
      </IconButton>
    </Dropdown>
  </div>;

  const menuEnd = <div>
    <div className="flex items-center">{children}</div>
    <Button
      label={<div className='flex'>
        <Icon name={`align-menu-${textoMenu.toLowerCase()}`} style={{ width: '20px', height: '20px' }} />
        <div style={{ marginLeft: '10px' }}>Posição do Menu</div>
      </div>}
      onChange={(e) => setValue(e.value)}
      style={{ display: isMobile || !isReturnEnabled ? 'none' : '' }}
      tooltipOptions={{ 'position': 'bottom' }}
      onClick={() => positionMenu()}
      className="p-button-text"
    >
    </Button>

    <Button
      label='Fechar Exame'
      icon="pi pi-times"
      className="p-button-text"
      onClick={() => FecharExame()}
      style={{ display: sessionStorage.getItem('auth') && acessoViewer ? '' : 'none' }}
    />
    <Button
      style={{ marginLeft: '8px' }}
      label='Sair'
      icon="pi pi-sign-out"
      className="p-button-text"
      onClick={() => setDialogConfirmacao(true)}
    />
  </div>;

  const renderFooter = <div style={{ textAlign: 'right' }}>
    <Button label="Sim" icon="pi pi-check" onClick={() => sair()} autoFocus />
    <Button label="Não" icon="pi pi-times" onClick={() => setDialogConfirmacao(false)} className="p-button-text" />
  </div>

  const sair = () => {
    if (sessionStorage.getItem('auth')) {
      sessionStorage.clear();
      sessionStorage.setItem('redirectUser', '1');
    } else {
      sessionStorage.setItem('redirectMsg', '1');
    }
    setTimeout(() => {
      window.location.href = window.location.origin;
    }, 500);
  }

  const FecharExame = () => {
    window.history.go(-1);
  }

  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  return (
    <>
      <Dialog
        header="Sobre"
        visible={dialogSobre}
        style={{ width: isMobile ? '80vw' : '40vw' }}
        onHide={() => setDialogSobre(false)}
        draggable={false}
        resizable={false}
      >
        <p><strong>Tzion WebViewer</strong></p>
        <p>O Tzion WebViewer possui funcionalidades avançadas como manipulação de imagem (panorâmica, zoom, janelas, predefinições, rotação, flip, rolagem, mira, filtragem), comparação de séries ou estudos, sincronização em série, reconstruções multiplanares e projeção de intensidade máxima entre outras funcionalidades que permitem um diagnóstico por imagem ainda mais assertivo.</p>
        <br></br>
        <div className='flex'>
          <div>
            <img alt="logo" src="/assets/logo-asl.png" width="85" height="85"></img>
          </div>
          <div style={{ marginLeft: '30px' }}>
            ASL SOFTHOUSE<br></br>
            Contato: +55 21 2742 8080<br></br>
            <a href="https://aslsofthouse.com.br">https://aslsofthouse.com.br</a> <br></br>
            <a href="mailto:contato@aslsofthouse.com.br">contato@aslsofthouse.com.br</a>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <br></br>
          <p>{window.config.versao}</p>
        </div>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={dialogConfirmacao}
        style={{ width: '25vw' }}
        //footer={renderFooter}
        position={'top'}
        onHide={() => setDialogConfirmacao(false)}
        draggable={false}
        resizable={false}
      >
        <br></br>
        <div style={{ textAlign: 'center' }}><p>Tem certeza que deseja sair da aplicação?</p></div><br></br>
        <br></br>
        {renderFooter}
      </Dialog >

      <Menubar
        start={menuStart}
        end={menuEnd}
        style={{ border: 'none', borderRadius: '0', background: '#040d19' }}
      ></Menubar>

    </>

  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
};

Header.defaultProps = {
  isReturnEnabled: true,
  isSticky: false,
};

export default Header;
